import React from "react";
import { Box } from "@components/Box/Box";
// import { Icon } from "@components/Icon/Icon";
import { Link, LinkProps } from "@components/Link/Link";
import styles from "./styles.module.scss";
import classnames from "classnames";

const getButtonVariant = (variant?: string): string => {
  return styles[`button--${variant}`];
};

const ButtonText: React.FC = ({ children }) => <Box as="span">{children}</Box>;
export interface ButtonProps extends React.ComponentPropsWithoutRef<"button"> {
  variant?: string;
}
const Button: React.FC<ButtonProps> = ({
  children,
  variant,
  className,
  ...props
}) => {
  const inner =
    typeof children === "string" ? (
      <ButtonText>{children}</ButtonText>
    ) : (
      children
    );
  return (
    <button
      disabled={props.disabled}
      className={classnames(
        styles.button,
        variant && getButtonVariant(variant),
        className && className
      )}
      {...props}
    >
      {/* {shape === "hexagon" && (
        <Icon
          sx={{
            ...buttonHexagonIconStyle,
            ...(!outline && { stroke: "transparent", fill: "white" }),
          }}
          svg={outline ? HexagonOutlineIcon : HexagonIcon}
        />
      )} */}
      {inner}
    </button>
  );
};

Button.defaultProps = {};

export interface ButtonLinkProps extends LinkProps {
  variant: string;
}
const ButtonLink: React.FC<ButtonLinkProps> = ({
  children,
  variant,
  className,
  ...props
}) => {
  const inner =
    typeof children === "string" ? (
      <ButtonText>{children}</ButtonText>
    ) : (
      children
    );

  return (
    <Link
      className={classnames(
        styles.button,
        variant && getButtonVariant(variant),
        className && className
      )}
      {...props}
    >
      {inner}
    </Link>
  );
};

ButtonLink.defaultProps = {};

export { Button, ButtonLink };
